<!-- navfooter -->
<app-navfooter></app-navfooter>
<!-- //.navfooter -->

<!-- footer -->
<footer>

    <!-- line -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-4 col-md-4 line line-right line-blue"></div>
            <div class="col-8 col-md-8 line line-left line-red"></div>
        </div>
    </div>
    <!-- //.line -->

    <!-- footerbar -->
    <div class="container footerbar">

        <div class="row">
            <div class="col-12 col-sm-4 col-md-4 col-lg-2 footerlogo">
                <a href="http://www.ba.gov.br/" target="_blank" rel="noopener">
                  <img src="./assets/images/brasao_rodape.png" class="img-fluid" alt="Logo do Governo da Bahia.">
                </a>
            </div>
            <div class="col-12 col-sm-8 col-md-8 col-lg-5 footer-address vertical-line-gray">
                <address>
                    <strong>SEFAZ | BA - Secretaria da Fazenda do Estado da Bahia</strong><br>
                    2ª Avenida nº 260  - Centro Administrativo da Bahia <br>
                    CEP 41.745-003, CAB, Salvador. Bahia.<br>
                    CNPJ 13.937.073/0001-56<br>
                </address>

                <p>Horário de funcionamento:
                    <br> De segunda à sexta-feira das 08:30 às 12:00 e 13:30 às 18:00h.
                </p>

                <ul class="list-inline">
                    <li class="list-inline-item"><i class="fa fa-phone-square" aria-hidden="true"></i>&nbsp;0800 071 0071</li>
                </ul>

            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 footer-navbar">

                <ul class="list-inline navfooter">
                    <li class="list-inline-item"><a href="http://www.ba.gov.br" target="_blank" rel="noopener">Portal do Governo</a></li>
                    <li class="list-inline-item"><a href="http://www.ouvidoriageral.ba.gov.br"  target="_blank" rel="noopener">Ouvidoria Geral</a></li>
                    <li class="list-inline-item"><a href="http://www.acessoainformacao.ba.gov.br/"  target="_blank" rel="noopener">Acesso à Informação</a></li>
                </ul>

                <select class="form-control" onchange="location = this.value;">
                    <option value="http://www.saeb.ba.gov.br/" class="first">Saeb - Sec. da Administração</option>
                    <option value="http://www.seagri.ba.gov.br/">Seagri - Sec. da Agricultura, Pecuária, Irrigação, Pesca, e Aquicultura</option>
                    <option value="http://www.sec.ba.gov.br/">Sec - Secretaria da Educação</option>
                    <option value="http://www.secom.ba.gov.br">Secom - Secretaria de Comunicação Social</option>
                    <option value="http://www.cultura.ba.gov.br/">Secult - Secretaria de Cultura</option>
                    <option value="http://www.secti.ba.gov.br/">Secti - Sec. de Ciência, Tecnologia e Inovação</option>
                    <option value="http://www.sdr.ba.gov.br/">SDR - Secretaria de Desenvolvimento Rural</option>
                    <option value="http://www.sedur.ba.gov.br/">Sedur - Secretaria de Desenvolvimento Urbano</option>
                    <option value="https://www.sefaz.ba.gov.br">Sefaz - Secretaria da Fazenda</option>
                    <option value="http://www.seinfra.ba.gov.br/">Seinfra - Secretaria de Infraestrutura</option>
                    <option value="http://www.meioambiente.ba.gov.br/">Sema - Secretaria do Meio Ambiente</option>
                    <option value="http://www.seap.ba.gov.br/">Seap - Sec. de Administração Penitenciária e Ressocialização</option>
                    <option value="http://www.mulheres.ba.gov.br/">SPM - Sec. de Políticas para as Mulheres</option>
                    <option value="http://www.seplan.ba.gov.br/">Seplan - Sec. do Planejamento</option>
                    <option value="http://www.sepromi.ba.gov.br/">Sepromi - Secretaria da Promoção de Igualdade Racial</option>
                    <option value="http://www.serin.ba.gov.br/">Serin - Secretaria de Relações Institucionais</option>
                    <option value="http://www.saude.ba.gov.br/">Sesab - Secretaria de Saúde</option>
                    <option value="http://www.setre.ba.gov.br/">Setre - Secretaria do Trabalho, Emprego, Renda e Esporte</option>
                    <option value="http://www.setur.ba.gov.br/">Setur - Secretaria de Turismo</option>
                    <option value="http://www.justicasocial.ba.gov.br/">SJDH - Secretaria de Justiça e Direitos Humanos</option>
                    <option value="http://www.justicasocial.ba.gov.br/">SEADES - Secretaria de Assistência e Desenvolvimento Social</option>                  
                    <option value="http://www.ssp.ba.gov.br/">SSP - Sec. da Segurança Pública</option>
                    <option value="http://www.sde.ba.gov.br/">SDE - Secretaria de Desenvolvimento Econômico</option>
                    <option value="http://www.sihs.ba.gov.br/" class="last">SIHS - Secretaria de Infraestrutura Hídrica e Saneamento</option>
                </select>
            </div>
        </div>
    </div>
    <!-- //.footerbar -->

</footer>
<!-- footer -->



// WEBPACK FOOTER //
// ./src/app/shared-layout/footer/footer.component.html